var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("关联附加险"),
      visible: _vm.dialogVisible,
      footer: null,
      width: 620
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-table", {
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: false,
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "limit",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text == 1 ? _vm.$t("选购") : text == 2 ? _vm.$t("必购") : "") + " ")];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };